/**
 * @deprecated Import from '@/components/atoms' or '@/atoms' instead.
 * This file is kept for backwards compatibility during migration.
 */

export { IconInput, Input } from '@/components/atoms/inputs';
export type { InputProps } from '@/components/atoms/inputs';
